import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

export const Index = {
    auth: authRoles.admin,
    routes: [
        {
            path: '/moo-rules',
            component: FuseLoadable({
                loader: () => import('./PaymentLineItemConfigsApp'),
            }),
        },
        {
            path: '/create-moo-rule',
            component: FuseLoadable({
                loader: () => import('./MutatePaymentLineItemConfigs'),
            }),
        },
        {
            path: '/edit-moo-rule/:id',
            component: FuseLoadable({
                loader: () => import('./MutatePaymentLineItemConfigs'),
            }),
        },
        {
            path: '/create-moo-rule-rate',
            component: FuseLoadable({
                loader: () => import('./payment-line-item-rate-form/MutatePaymentLineItemRate'),
            }),
        },
        {
            path: '/edit-moo-rule-rate/:id',
            component: FuseLoadable({
                loader: () => import('./payment-line-item-rate-form/MutatePaymentLineItemRate'),
            }),
        },
        {
            path: '/effective-moo-rule-rates/:id',
            component: FuseLoadable({
                loader: () => import('./effective-payment-line-item-rate/ViewEffectiveLineItemRates'),
            }),
        },
        {
            path: '/create-effective-rates/:id',
            component: FuseLoadable({
                loader: () => import('./effective-payment-line-item-rate/MutateEffectiveLineItemRate'),
            }),
        },
        {
            path: '/edit-effective-rates/:id/:effectiveRateId',
            component: FuseLoadable({
                loader: () => import('./effective-payment-line-item-rate/MutateEffectiveLineItemRate'),
            }),
        },
    ],
};

export default [Index];
